import * as $ from 'jquery';
import 'jquery-colorbox';
import Debouncer from '../lib/Debouncer';
import Carousel from './Carousel';
import Forms from './Forms';

const locationTour = () => {
	let tourCode: any = null;

	$('a[href*="lab-tour-"]').colorbox({
		transition: 'elastic',
		opacity: .60,
		initialWidth: '200',
		initialHeight: '200',
		width: '100%',
		height: '100%',
		maxWidth: '100%',
		maxHeight: '100%',
		fixed: true,
		close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" height="44" fill="#FFFFFF"><path d="M13.458 15.336l1.485-1.485 15.344 15.344-1.485 1.485z"> </path><path d="M12.961 29.2l15.344-15.343 1.485 1.485-15.344 15.344z"> </path></svg><span>Close</span>',
		html: () => {
			if (tourCode === null) {
				// First time loading tour.
				const indirection: any = {};
				$.ajax($.colorbox.element().attr('href'), { async: false, success: data => indirection.result = data });
				tourCode = $(indirection.result).find('#locationTour');
			}
			return tourCode;
		},
		onComplete: () => {
			const carouselElem = document.querySelector('.carousel--locationTour');
			if (carouselElem && !carouselElem.getAttribute('data-setuptourcontents')) {
				carouselElem.setAttribute('data-setuptourcontents', 'true');

				new Carousel({
					analyticsCategory: 'Carousel',
					carouselEl: carouselElem as HTMLElement,
					duration: 7500,
					allowIndicatorClick: true,
					allowLooping: false,
					autoHeight: true,
					startingIndex: -1,
					progressEl: carouselElem as HTMLElement
				});

				Forms.init();
			}

			const resizeDebouncer = new Debouncer(() => {
				$.colorbox.resize({
					width: '100%',
					height: '100%'
				});
			});
			window.addEventListener('resize', resizeDebouncer.run);
			resizeDebouncer.runNow();
		},
		onOpen: () => {
			document.querySelector('html').classList.add('lockScroll');
		},
		onClosed: () => {
			document.querySelector('html').classList.remove('lockScroll');
		}
	});
};

export default locationTour;
